import axios from './base'
const url = `/official`

// ================= 官方内容管理（后端 OfficialContentService，tb_official_content，/official*） =================

// 官方内容列表（分页 + 筛选：keyword 标题/摘要模糊 / category 字典 _id 精确 / type 1图文 2视频 / status 0草稿 1发布 2下架）
// 返回 data:{list,total,page,page_size}；列表按 状态→发布时间(空取创建时间) 倒序
export function getOfficialList(params = {}) {
  return axios.request({
    url: `${url}`,
    method: "get",
    params,
  })
}

// 官方内容详情
export function getOfficialDetail(id, params = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "get",
    params,
  })
}

// 新增官方内容（category 存字典 content_category 的数字 _id；type=1 带 content、type=2 带 video_url）
export function createOfficial(data = {}) {
  return axios.request({
    url: `${url}`,
    method: "post",
    data,
  })
}

// 编辑官方内容
export function updateOfficial(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "put",
    data,
  })
}

// 删除官方内容（软删）
export function deleteOfficial(id, data = {}) {
  return axios.request({
    url: `${url}/${id}`,
    method: "delete",
    data,
  })
}

// 状态流转（body: {status: 0草稿 | 1发布 | 2下架}；发布时 publish_time 为空后端自动补当前时间）
export function updateOfficialStatus(id, data = {}) {
  return axios.request({
    url: `${url}/${id}/status`,
    method: "put",
    data,
  })
}
